export default __webpack_public_path__ + "static/media/chevron-down.c3e123cf.svg";